import { Link } from "react-router-dom"
import { Diagnosis } from "../types/Diagnosis"


const DiagnosesCard = ({ answeredAt, diagnosis }: Props) => {

    return (
        <div className="w-full h-24 bg-white p-3 flex flex-col border rounded-md relative overflow-hidden">
            {
                answeredAt &&
                <span
                    className="w-1.5 h-full absolute z-10 top-0 left-0 bg-green-500"
                />
            }
            <div className="w-full flex-1 font-semibold ">
                {diagnosis?.name}
            </div>
            <div className="flex justify-between text-sm" >
                <div className={(answeredAt ? ' text-green-500' : '')}> {diagnosis?.questions_count} questões </div>
                {
                    answeredAt &&
                    <Link to={`/osc/resultado/${diagnosis?.id}`} className="text-gray-600  cursor-pointer">
                        {answeredAt}
                    </Link>
                }
                {
                    !answeredAt &&
                    <Link to={`/osc/responder/${diagnosis?.id}`} className="text-primary cursor-pointer font-semibold text-base">
                        Responder
                    </Link>
                }
            </div>
        </div>
    )
}

interface Props {
    answeredAt?: string,
    diagnosis?: Diagnosis
}

export default DiagnosesCard
